import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';

const CounterWithLabel = function CounterWithLabel({
  label = '',
  value = 0,
  color = 'primary.main',
  reverse = false,
  labelVariant = 'h6',
  title = '',
}) {
  return (
    <Tooltip title={title} placement="top" arrow>
      <Box
        sx={{
          display: 'flex',
          flexDirection: reverse ? 'column-reverse' : 'column',
          alignItems: 'center',
          marginRight: '16px',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant={labelVariant}
          sx={{
            color,
            fontWeight: 'bold',
            cursor: title && 'pointer',
          }}
        >
          {value}
        </Typography>
        <Typography variant="subtitle2" color="textSecondary">
          {label}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default CounterWithLabel;
